import React, { useState, useEffect, useRef } from "react";
import AceEditor from "react-ace";
import '../assets/css/compiler.css';
import { runPythonCode } from "../utils/run_code";
import useStore from "../store";

// Import the required mode and theme for Python and Dark theme
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-language_tools";
import VisalizationComponent from "../components/Visualization";
import Footer from "../components/Footer";

const Compiler = () => {
  const [code, setCode] = useState(`\n# write your python code above to visualize\nprint("Do not remove this print statement")`);
  const [output, setOutput] = useState("");

  const editorRef = useRef(null);
  const currentLine = useStore((state) => state.currentLine);

  useEffect(() => {
    const editor = editorRef.current?.editor;
    if (!editor) return;

    const session = editor.getSession();
    const lineCount = session.getLength();

    for (let i = 0; i < lineCount; i++) {
      session.removeGutterDecoration(i, "lilac-gutter-highlight");
    }

    if (typeof currentLine === "number") {
      session.addGutterDecoration(currentLine - 1, "lilac-gutter-highlight");
      editor.scrollToLine(currentLine - 1, true, true);
    }
  }, [currentLine]);

  const handleCodeChange = (newCode) => {
    setCode(newCode);
  };

  const handleSubmit = async () => {
    try {
      const output = await runPythonCode(code);
      setOutput(output || "Code executed successfully with no output.");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="main-compiler-container">
      <div className="left-side">
        {/* Editor */}
        <AceEditor
          ref={editorRef}
          mode="python"
          placeholder="Write code here to visualize"
          theme="monokai"
          name="UNIQUE_ID_OF_DIV"
          value={code}
          onChange={handleCodeChange}
          editorProps={{ $blockScrolling: true }}
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            fontSize: "18px",
            wrap: true,
          }}
          style={{
            height: "90vh",
            width: "40vw",
          }}
        />

        {/* Run Button */}
        <button onClick={handleSubmit} style={{ marginTop: "10px", padding: "8px 16px" }}>
          Run Code
        </button>

        {/* Output Box */}
        <div
          style={{
            marginTop: "12px",
            padding: "10px",
            backgroundColor: "#1e1e1e",
            color: "#d4d4d4",
            fontFamily: "monospace",
            fontSize: "14px",
            borderRadius: "8px",
            border: "1px solid #444",
            whiteSpace: "pre-wrap",
            overflowY: "auto",
            maxHeight: "200px",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <strong style={{ display: "block", marginBottom: "8px", color: "#9cdcfe" }}>Output:</strong>
          {output}
        </div>
      </div>

      <div className="right-side" style={{ marginBottom:"25px", paddingBottom:"50px" }}>
        <VisalizationComponent code={code} />
      </div>
      <Footer />
    </div>
  );
};

export default Compiler;
